<template>
  <div class="contractor_registered contain">
    <MyTransition :myName="'up'">
      <Popup v-if="popupStatus">
        <PopupSuccess v-if="popup == 'success'" :text="successText" @check="poupupEnter"></PopupSuccess>
        <PopupError v-if="popup == 'error'" :text="successText" @check="poupupEnter"></PopupError>
      </Popup>
    </MyTransition>
    <div class="form_input flex" v-for="(field, index) in formField" :key="index">
      <label :class="checkOK.includes(field.name) ? 'label_must_error' : ''">
        {{ field.name }}
        <span v-if="field.must">*</span>
      </label>
      <!--switch-->
      <div v-if="field.type == 'switch'">
        <el-switch v-model="formInput[field.val]" :active-text="field.switchText[0]"
          :inactive-text="field.switchText[1]"></el-switch>
      </div>
      <div v-else-if="field.type == 'select'">
        <el-select class="el_select" v-model="formInput[field.val]" placeholder="請選擇">
          <el-option v-for="item in options.department" :key="item.department_id" :label="item.department"
            :value="item.department_id"></el-option>
        </el-select>

      </div>
      <div v-else>
        <!-- 其他 -->
        <input type="text" class="input_primary" :placeholder="field.placeholder" v-model.trim="formInput[field.val]" />
      </div>
    </div>
    <!--驗證碼-->
    <!-- <div class="verification_block flex">
      <Verification ref="verification"></Verification>
    </div>-->
    <div class="register_btn">
      <button class="btn_primary" @click="enter">資料送出</button>
    </div>
  </div>
</template>

<style lang="scss">
.el-date-picker__header {
  display: flex;
  align-items: center;
}

.contractor_registered {
  margin: 30px;
  text-align: left;
  background: #fff;
  border-radius: 10px;
  // box-shadow: 20px 20px 40px -30px rgba($color: #000000, $alpha: 0.5);
  box-shadow: 0px 0px 25px -10px rgba($color: #000000, $alpha: 0.5);

  .form_input {
    flex-wrap: wrap;
    white-space: nowrap;

    label {
      flex: 3;
      font-weight: bold;

      span {
        color: var(--subColor);
      }
    }

    >div {
      flex: 7;

      input,
      textarea {
        width: 100%;
      }
    }

    .el_select {
      width: 100%;
    }
  }

  .verification_block {
    border-top: 1px dashed #ccc;
    padding-top: 15px;
    margin-top: 40px;
    justify-content: flex-end;
  }
}

.form_input {
  align-items: center;
  font-size: 15px;
  margin: 15px 0;

  label {
    &.label_must_error {
      color: var(--subColor);
    }
  }

  .el_elment {
    flex: 7;
    width: 100%;

    .el-select {
      width: 100%;
    }

    .el-date-editor.el-input,
    .el-input {
      width: 100%;

      .el-input__prefix {
        display: none;
      }

      input {
        padding: 8px 10px;
        border-radius: 5px;
        background: #e5e5e5;
        border: 1px solid #e5e5e5;
        box-shadow: 1px 1px 2px -1px rgba(0, 0, 0, 0.2) inset;

        &:hover,
        &:focus {
          background: #fff;
          border: 1px solid #e5e5e5;
          box-shadow: none;
        }

        /*webkit瀏覽器專用*/
        &::-webkit-input-placeholder {
          color: #b6b6b6;
        }

        /*Firefox 4-18瀏覽器專用*/
        &::-moz-placeholder {
          color: #b6b6b6;
        }

        /*IE10瀏覽器專用*/
        &:-ms-input-placeholder {
          color: #b6b6b6;
        }
      }
    }
  }
}

.form_dow {
  margin: 20px 0;
  background: #f0f0f0;
  padding: 20px 10px;
  border-radius: 10px;

  .title {
    font-size: 20px;
    font-weight: bold;
  }

  .dow_btn {
    margin-top: 10px;
    justify-content: space-around;
    flex-wrap: wrap;

    button {
      margin: 3px;
      box-shadow: 10px 10px 20px -10px rgba($color: #000000, $alpha: 0.5);

      &:hover {
        box-shadow: 2px 2px 1px -1px rgba($color: #000000, $alpha: 0.5);
      }
    }
  }
}

.form_upload {
  margin: 20px 0 0 0;

  .title {
    font-size: 20px;
    font-weight: bold;
  }

  .upload_btn {
    >div {
      margin: 15px 0;
      width: 100%;

      input {
        display: none;
      }
    }

    label {
      display: block;
      font-size: 14px;
      cursor: pointer;
      padding: 12px 20px;
      width: 100%;
      text-align: center;
      border-radius: 5px;
      color: #737373;
      border: 2px dashed #ccc;

      &:hover {
        border: 2px dashed var(--mainColor);
        color: var(--mainColor);
        font-weight: bold;
      }

      .cancel_file {
        padding: 0 10px;
      }
    }
  }
}

.register_btn {
  margin: 10px 0 10px 0;

  >button {
    margin: 10px 0;
  }

  .btn_light {
    box-shadow: 10px 10px 20px -10px rgba($color: #000, $alpha: 0.4);

    &:hover {
      box-shadow: 3px 3px 5px -1px rgba($color: #000, $alpha: 0.4);
    }
  }

  .btn_border {
    border: 1px solid var(--mainColor);
    color: var(--mainColor);
  }
}
</style>

<script>
import Verification from "@/components/Verification.vue";

export default {
  name: "adminAddContractor",
  data() {
    return {
      formInput: {
        department_id: null,
        tax_id: null,
        email: null,
        vendor_chinese: null
      },
      popupStatus: false,
      successText: null,
      popup: null,
      checkOK: [],
      formData: new FormData(),
      formField: [
        {
          name: "廠商公司名稱",
          val: "vendor_chinese",
          placeholder: "中文",
          must: true,
          type: "input",
          switchText: null
        },
        {
          name: "合格證廠商名稱",
          val: "vendor_short_name",
          placeholder: "",
          must: true,
          type: "input",
          switchText: null
        },
        {
          name: "廠商統一編號",
          val: "tax_id",
          placeholder: "登入帳號",
          must: true,
          type: "input",
          switchText: null
        },
        {
          name: "廠商E-mail",
          val: "email",
          placeholder: null,
          must: true,
          type: "input",
          switchText: null
        },
        {
          name: "需求單位",
          val: "department_id",
          placeholder: null,
          must: true,
          type: "select",
          switchText: null
        }
      ],
      options: {
        department: [],
      }
    };
  },
  components: {
    Verification
  },
  methods: {
    enter() {
      this.checkOK = [];
      //判斷必填
      this.formField.forEach(el => {
        if (
          el.must &&
          (this.formInput[el.val] == null || this.formInput[el.val].length == 0)
        ) {
          //必填且欄位沒有值
          //去除掉選項是false的項目
          this.checkOK.push(el.name);
        }
      });

      if (this.checkOK.length !== 0) {
        //必填有遺漏
        this.popupStatus = true;
        this.popup = "error";
        this.successText = `請填寫:${this.checkOK.join()}`;
      }

      if (this.checkOK.length == 0) {
        //必填完成
        this.formData.append("form_input", JSON.stringify(this.formInput));
        this.$http.api.login
          .vendorRegister(this.formData, {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded"
            }
          })
          .then(res => {
            this.popupStatus = true;
            this.successText = "註冊成功，系統將會發信通知承攬商及需求單位";
            this.popup = "success";
          })
          .catch(error => {
            this.popupStatus = true;
            this.popup = "error";
            if (error.error.tax_id) {
              this.successText = "已經有重複註冊的統一編號存在";
            } else {
              this.successText = "註冊失敗";
            }
          });
      }
    },
    poupupEnter() {
      this.popupStatus = false;
      if (this.popup == "success") {
        for (let key in this.formInput) {
          this.formInput[key] = null
        }
      }
    },
    getDepartment() {
      this.$http.api.admin.department().then(res => {
        this.options.department = res.data
      })
    }
  },
  mounted() {
    this.getDepartment()
  }
};
</script>